<ng-container *transloco="let t">
<div class="modal-header">

  <h2>{{ t('auth.existingAccount.title') }}</h2>

  <!-- hack to fool ngbModal autofocus -->
  <input type="text" style="display:none" />

  @if (!spinnerVisible) {
    <div class="btn btn-icon btn-sm btn-active-light-primary ms-2" aria-label="Close"
      (click)="activeModal.dismiss('Cross click')">
      <span class="svg-icon svg-icon-2x">
        <close-x-svg-icon></close-x-svg-icon>
      </span>
    </div>
  }
</div>

<div class="modal-body py-5 px-lg-17">
  <div class="alert alert-info d-flex align-items-center p-5 mb-10">
    <span class="svg-icon svg-icon-2hx svg-icon-info me-3">
      <duotone-shield-check-svg-icon></duotone-shield-check-svg-icon>
    </span>
    @if (userName) {
      <div class="d-flex flex-column">
        <span class="mb-3">{{ t('auth.existingAccount.alreadyHaveAccount') }} <strong>{{ userName }}</strong>.</span>
      </div>
    }
  </div>
  @if (errorMessage) {
    <div class="alert alert-danger d-flex align-items-center p-5 mb-10">
      <span class="svg-icon svg-icon-2hx svg-icon-danger me-3">
        <duotone-warning-circle-svg-icon></duotone-warning-circle-svg-icon>
      </span>
      <div class="d-flex flex-column">
        <span>{{errorMessage}}</span>
      </div>
    </div>
  }
  <form #loginForm="ngForm" class="form" novalidate id="loginForm" name="loginForm">
    <div class="row mb-4">
      <h5 class="col-md-12 fv-row">
        {{ t('auth.existingAccount.newLoanOrManage') }}
      </h5>
    </div>
    <div class="row">
      <div class="col-md-12 fv-row">
        <div class="mb-8 d-flex flex-column">
          <div class="form-check form-check-custom form-check-solid form-check-sm flex-fill mb-3">
            <input class="form-check-input" type="radio" [value]="false" name="manageExistingLoans"
              id="manageExistingLoans" [(ngModel)]="applyingForANewLoan">
            <label class="form-check-label" style="font-size:1.1rem" for="manageExistingLoans">{{ t('auth.existingAccount.manageExistingLoans') }}</label>
          </div>
          <div class="form-check form-check-custom form-check-solid form-check-sm flex-fill">
            <input class="form-check-input" type="radio" [value]="true" name="applyingForANewLoan" checked="checked"
              id="applyingForANewLoan" [(ngModel)]="applyingForANewLoan">
            <label class="form-check-label" style="font-size:1.1rem" for="applyingForANewLoan">{{ t('auth.existingAccount.applyForNewLoan') }}</label>
          </div>
        </div>
      </div>
    </div>
    @if (!createApplicationRequest.password) {
      <div class="row">
        <div class="fv-row mb-5">
          <div class="d-flex flex-stack mb-2">
            <label class="form-label fw-bolder text-dark fs-6 mb-0" for="password">{{ t('auth.existingAccount.password') }}</label>
            <a class="link-primary fs-6 fw-bolder" (click)="onForgotPasswordClicked()">{{ t('auth.existingAccount.forgotPassword') }}</a>
          </div>
          <input class="form-control form-control-lg form-control-solid" type="password" name="password" required
            [ngClass]="{'is-invalid' : userPassword && userPassword.touched && userPassword.invalid}" autocomplete="off"
            [(ngModel)]="password" #userPassword="ngModel" />
          <div class="invalid-feedback">{{ t('auth.existingAccount.pleaseEnterPassword') }}</div>
        </div>
      </div>
    }
  </form>
</div>

<div class="modal-footer flex-center">
  @if (!spinnerVisible) {
    <button type="button" class="btn btn-white me-3" (click)="activeModal.dismiss()">{{ t('common.cancel') }}</button>
  }
  <button type="submit" class="btn btn-primary" (click)="onLoginClicked()" [disabled]="spinnerVisible">
    <span class="indicator-label">{{loginButtonText}}</span>
    @if (spinnerVisible) {
      <span class="spinner-border spinner-border-sm align-middle ms-2"></span>
    }
  </button>
</div>
</ng-container>
